// Generated by //tools/generate_template_variable_aliases. Do not edit.
export const TEMPLATE_VARIABLE_ALIASES = {
    client_name: 'client_first_name',
    patient_address: 'client_address',
    patient_city: 'client_city',
    patient_first_name: 'client_first_name',
    patient_last_name: 'client_last_name',
    patient_name: 'client_first_name',
    patient_state: 'client_state',
    patient_street_name: 'client_street_name',
    patient_zip_code: 'client_zip_code',
} as const satisfies Readonly<Record<string, string>>;

export const TEMPLATE_VARIABLE_CANONICAL_VALUE_ONLY_ALIASES: ReadonlySet<string> =
    new Set(['client_name', 'patient_name']);
